import React from 'react';
import { Card, Row, Col, Statistic, Typography, Progress, Table } from 'antd';
import {
  BarChartOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const QualityAnalytics: React.FC = () => {
  const ncrTrendColumns = [
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count',
    },
    {
      title: 'Trend',
      dataIndex: 'trend',
      key: 'trend',
      render: (trend: string) => (
        <span style={{ color: trend === 'decreasing' ? '#52c41a' : '#ff4d4f' }}>
          {trend === 'decreasing' ? '↓' : '↑'} {trend}
        </span>
      ),
    },
  ];

  const ncrTrendData = [
    {
      key: '1',
      category: 'Material Defects',
      count: 12,
      trend: 'decreasing',
    },
    {
      key: '2',
      category: 'Dimensional Non-Conformance',
      count: 8,
      trend: 'stable',
    },
    {
      key: '3',
      category: 'Process Issues',
      count: 5,
      trend: 'decreasing',
    },
  ];

  return (
    <div>
      <Title level={2}>
        <BarChartOutlined /> Quality Analytics
      </Title>
      <Paragraph>Quality management metrics and continuous improvement insights.</Paragraph>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Quality Rating"
              value={95.2}
              precision={1}
              suffix="%"
              prefix={<SafetyCertificateOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Open NCRs"
              value={25}
              prefix={<WarningOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="CAPAs Completed"
              value={42}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#145A54' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Inspection Pass Rate"
              value={96.8}
              precision={1}
              suffix="%"
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Quality Performance" bordered={false}>
            <div style={{ marginBottom: 16 }}>
              <div style={{ marginBottom: 8 }}>
                <span>First Pass Inspection Rate</span>
                <Progress percent={96.8} status="active" strokeColor="#52c41a" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <span>Customer Complaint Resolution</span>
                <Progress percent={92.0} status="active" strokeColor="#145A54" />
              </div>
              <div style={{ marginBottom: 8 }}>
                <span>CAPA Effectiveness</span>
                <Progress percent={88.5} status="active" strokeColor="#faad14" />
              </div>
            </div>
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="NCR Trend by Category" bordered={false}>
            <Table
              columns={ncrTrendColumns}
              dataSource={ncrTrendData}
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24}>
          <Card title="Quality Cost Analysis" bordered={false}>
            <Paragraph>Cost of quality breakdown (prevention, appraisal, failure) would appear here.</Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default QualityAnalytics;
